/** "hidroxido_de_aluminio_hidroxido_de_magnesio" → "hidroxido de aluminio hidroxido de magnesio" (vista). */
export function textoPa(pa: string | null | undefined): string {
  return (pa ?? '').replace(/_/g, ' ').replace(/\s+/g, ' ').trim()
}
